<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <div class="subBlockContent" id="addsoftware">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false"
        (currentLoadingStatus)="onLoading($event)"></loading-screen>
      <div class="row filter-wrapper">
        <div class="col-md-6">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" #searchValue placeholder="Filter"
              [(ngModel)]="searchSoftwareSubscription" (ngModelChange)="filterSoftwareSubscriptionItems()">
          </div>
        </div>
        <!-- # brand filter -->
        <div class="listpart col-md-6">
          <mat-form-field>
            <input class="perpetualmpn" type="number" name="matmpnid" placeholder="Select / Enter New MPN ID"
              aria-label="Number" #trigger="matAutocompleteTrigger" [(ngModel)]="softwareSubscriptionMpnIdSelect"
              matInput [matAutocomplete]="auto" (blur)="confirmMpnID(softwareSubscriptionMpnIdSelect)">
            <mat-spinner mode="indeterminate" class="spinnerPosition" diameter="15" *ngIf="isCheck"></mat-spinner>
            <i class="material-icons align-arrow-right"
              (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                {{mpn}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <!-- <ng-select class="customDropdwon" [items]="mpnList" bindValue="mpn" bindLabel="mpn" placeholder="Select / Enter New MPN ID" 
          [(ngModel)]="softwareSubscriptionMpnIdSelect" (blur)="confirmMpnID(softwareSubscriptionMpnIdSelect)">
          </ng-select> -->
        </div>
        <div class="col-md-12 align-center" *ngIf="!softwareSubscriptionAddItems?.length && loadContent">
          <label class="noData-label">
            We couldn’t find any perpetual item
          </label>
        </div>
        <div class="col-md-12" *ngIf="softwareSubscriptionAddItems?.length && loadContent">
          <div class="shared-outer-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="align-left" style="width: 20%">STOCK CODE</th>
                  <th scope="col" class="align-left" style="width: 50%">TITLE</th>
                  <th scope="col" class="align-center" style="width: 10%">PRICE</th>
                  <th scope="col" class="align-center" style="width: 10%">QUANTITY</th>
                  <th scope="col" class="align-center" style="width: 10%"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let software of softwareSubscriptionAddItemsFilter">
                  <td class="align-center" style="position: relative;vertical-align: middle; text-align: left">
                    {{software?.stockCode}}
                  </td>
                  <td style="position: relative;vertical-align: middle;">
                    <span class="description-popup">{{software?.title}}</span>
                  </td>
                  <td class="align-right" style="position: relative;vertical-align: middle;">
                    {{software?.itemPrice}}
                  </td>
                  <td class="align-center" style="position: relative;vertical-align: middle;">
                    <input class="align-center input-wrapper input-wrapper-small" [(ngModel)]="software.quantity"
                      type="text">
                    <mat-icon matSuffix *ngIf="software?.minMaxQtyText" class="editmpnidicon align-top"
                      placement="bottom" ngbTooltip="{{software?.minMaxQtyText}}">info</mat-icon>
                  </td>
                  <td class="align-center" style="vertical-align: middle;">
                    <button class="button button-red button-mid confirmbutton"
                      id="{{software?.stockCode.replace(':', '_')}}" *ngIf="!software?.isExisting"
                      (click)="AddSoftwareSubscription(software)" [disabled]="!checkMpnId">Add</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button-center">
            <button *ngIf="softwareSubscriptionAddItems?.length && loadContent"
              class="button button-red button-large saveuser" (click)="finishAddSoftware()">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>